import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";
 
export default () => {

  const moduleName = "wholesale_rules";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.wholesale_rules_destroy, location.search]);

  useEffect(() => {
    if (appReducer.wholesale_rules_list != undefined) {
      setRows(appReducer.wholesale_rules_list.data)
      setTotalPages(appReducer.wholesale_rules_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام',
      selector: row => row.name,
    },
    {
      name: 'بازه تعدادی',
      selector: row => `${row.min} - ${row.max}`,
    },
    {
      name: 'دسته‌بندی فروش عمده',
      selector: row => row.wholesale.name,
    },
    {
      name: 'درصد تخفیف',
      selector: row => `${row.discount}%`,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table  count={totalPages}  columns={columns} data={rows} />;

};
